module.exports = __webpack_public_path__ + "img/yrityslainaa-5000-euroa.c5718df.jpg";